module.exports = __webpack_public_path__ + "img/delete-firend.af30cec9.png";